/**
 * Model artifact — Zod schemas & types
 *
 * An "artifact" is a versioned file (GGUF model, ChromaDB data, etc.)
 * stored in the artifact repository. Versions auto-increment per name.
 */
import { z } from 'zod';
export const ArtifactStatusSchema = z.enum(['uploading', 'ready', 'failed', 'archived']);
/** Full model artifact entity (API response shape) */
export const ModelArtifactSchema = z.object({
    id: z.string().uuid(),
    modelName: z.string(),
    version: z.number().int().positive(),
    status: ArtifactStatusSchema,
    sha256: z.string().length(64),
    fileSizeBytes: z.number(),
    baseModel: z.string(),
    quantization: z.string().nullable().optional(),
    trainingRunId: z.string().uuid().nullable().optional(),
    modelfileContent: z.string().nullable().optional(),
    storagePath: z.string(),
    metadata: z.record(z.unknown()).default({}),
    publishedBy: z.number().nullable().optional(),
    description: z.string().nullable().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** Initiate upload request body */
export const InitiateUploadSchema = z.object({
    modelName: z.string().min(1).max(255),
    sha256: z.string().length(64),
    fileSizeBytes: z.number().int().positive(),
    baseModel: z.string().min(1),
    quantization: z.string().max(50).optional(),
    trainingRunId: z.string().uuid().optional(),
    modelfileContent: z.string().min(1).optional(),
    fileName: z.string().max(255).optional(),
    metadata: z.record(z.unknown()).optional(),
    description: z.string().optional(),
});
//# sourceMappingURL=model-artifact.js.map